var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.6C14 0.93 13.7375 1.2 13.4167 1.2H0.583333C0.2625 1.2 0 0.93 0 0.6C0 0.27 0.2625 0 0.583333 0H13.4167C13.7375 0 14 0.27 14 0.6ZM8.75 10.8H5.25C4.92917 10.8 4.66667 11.07 4.66667 11.4C4.66667 11.73 4.92917 12 5.25 12H8.75C9.07083 12 9.33333 11.73 9.33333 11.4C9.33333 11.07 9.07083 10.8 8.75 10.8ZM11.0833 5.4H2.91667C2.59583 5.4 2.33333 5.67 2.33333 6C2.33333 6.33 2.59583 6.6 2.91667 6.6H11.0833C11.4042 6.6 11.6667 6.33 11.6667 6C11.6667 5.67 11.4042 5.4 11.0833 5.4Z",
    fill: "#030304"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.ce9a4a0fbfc69f15359e0dc1e6d3702e.svg";
export { ForwardRef as ReactComponent };